<template>
  <TagComponent
    :id="id"
    :label="label"
    :bg-colour="bgColour"
    :title="title">
    <template #icon>
      <SuccessIcon />
    </template>
  </TagComponent>
</template>
<script setup lang="ts">
import TagComponent from '@/components/ui-components/TagComponent.vue'
import SuccessIcon from '../ui-components/icons/SuccessIcon.vue'

const props = defineProps({
  id: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: 'Auto extracted',
  },
  bgColour: {
    type: String,
    default: 'science-blue-20',
  },
  title: {
    type: String,
    default: 'This was auto-filled from your previous submission',
  },
})

const { id, label, bgColour, title } = props
</script>
